import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import ApartmentNameChip from '../ApartmentNameChip';

function Tag({ addAllOptionsId, getTagProps, hasAddAllOptions, newItemId, tagValue }) {
  return tagValue.map((option, index) => {
    if (option.id === newItemId) {
      return <Chip color="primary" key={option.id} label={option.label || ''} {...getTagProps({ index })} />;
    }
    if (hasAddAllOptions && option.id === addAllOptionsId) {
      return <Chip color="primary" key={option.id} label={option.label || ''} {...getTagProps({ index })} />;
    }
    return (
      <ApartmentNameChip
        key={option.id}
        name={option.name}
        number={option.number}
        size="default"
        {...getTagProps({ index })}
      />
    );
  });
}

Tag.propTypes = {
  addAllOptionsId: PropTypes.string,
  getTagProps: PropTypes.func.isRequired,
  hasAddAllOptions: PropTypes.bool,
  newItemId: PropTypes.string.isRequired,
  tagValue: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Tag;
